jQuery.feature_import("js-order-locks",
    () => require("./OrderLocks.jsx"),
    mod => mod.feature_js_order_locks
);